import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import Axios from 'axios'

export default function Pending() {
    const [agent,setAgent] = useState('')
    const [agentCode, setAgentcode] = useState('')
    const [proposals, setProposals] = useState([])
    const [credentials, setCredentials] = useState(null)
    const [isAuth, setIsauth] = useState(false)
    const company = 'Definite'
        const [search, setSearch] = useState('');
        const [startDate, setStartdate] = useState('');
        const [endDate, setEnddate] = useState('');
        const [policies, setPolicies] = useState([])
        const [currentPage, setCurrentPage] = useState(1);
        const [selectedProposal, setSelectedproposal] = useState('');
        const [productName, setProductname] = useState('');
        const [productCode, setProductcode] = useState('')
        const [policyNumber, setPolicynumber] = useState('');
        const [client, setClient] = useState('');
        const [clientCode, setClientcode] = useState('')
        const [coverPeriod, setCoverperiod] = useState('');
        const [commence, setCommence] = useState('');
        const [commence1, setCommence1] = useState('');
        const [expiry, setExpiry] = useState('');
        const [expiry1, setExpiry1] = useState('');
        const [insuredItemcode, setInsureitemcode] = useState('');
        const [insuredItemname, setInsureditemname] = useState('');
        const [premiumAmount, setPremiumamount] = useState(0);
        const [reg, setReg] = useState('');
        const [makeCode, setmakeCode] = useState('')
        const [makeName, setMakename] = useState('')
        const [modelCode,setModelcode] = useState('')
        const [color, setColor] = useState('')
        const [yom, setYom] = useState('')
        const [tonnage, setTonnage] = useState('')
        const [chassis, setChassis] = useState('')
        const [engine, setEngine] = useState('')
        const [capacity, setCapacity] = useState('')
        const [sumInsured, setSuminsured] = useState(0)
        const [certUrl, setCerturl] = useState('')
        const [cc,setCC] = useState('')
        const [insuredItem, setInsureditem] = useState('')
        const [proposalNo, setProposalno] = useState('')
        const [dateDone, setDatedone] = useState('')
        const [commission, setCommission] = useState(0)
        const [modal, setModal] = useState(false)
        const [modal2, setModal2] = useState(false)
        const [selectedOption, setSelectedOption] = useState('GROSS');
        const [payAmount, setPaymount] = useState(0)
        const [mobile, setMobile] = useState('')
        const [optionCode, setOptioncode] = useState('')
        const [optionName, setOptionname] = useState('')
        const [isCert, setIscert] = useState(0)
        const [certURL, setCertURL] = useState('')
        const [today, setToday] = useState('')
        const [PHCF, setPHCF] = useState('')
        const [netCommission,setNetcommission] = useState('')
        const [trainingLevy, setTraininglevy] = useState('')
        const [whtax, setWhtax] = useState('')
        const [extensionStartdate, setExtensionstartdate] = useState(null)
        const [extesnionExpirydate, setExtensionexpirydate] = useState(null)
        const [commissionRate, setCommissionrate] = useState('')
        const rowsPerPage = 20;
        const [netPremium, setNetpremium] = useState('')
        const totalPages = Math.ceil(policies.length / rowsPerPage);
        const indexOfLastRow = currentPage * rowsPerPage;
        const indexOfFirstRow = indexOfLastRow - rowsPerPage;
        const currentPolicies = policies.slice(indexOfFirstRow, indexOfLastRow)
        const [extendText, setExtendtext] = useState('EXTEND POLICY')
        const [insuredOID, setInsuredOID] = useState('')
        const [bodyType, setBodytype] = useState('')
        const [commencementDate, setCommencementDate] = useState('')
        const [expiryDate, setExpirydate] = useState('')
        const [clientEmail, setClientemail] = useState('');
        const [clientPin, setClientpin] = useState('')
        const [iraCode, setIracode] = useState('')
        const [iraNumber, setIranumber] = useState('')
        const [eMessage,setEmessage] = useState('')
        const [commencementUnix, setCommencementunix] = useState(null)
        const [expiryUnix, setExpiryunix] = useState(null)
        const [commencement, setCommencement] = useState(null)
        const [numberOfDays, setNumberOfDays] = useState(0);
        const [premium,setPremium] = useState(0)
        const [basicPremium, setBasicpremium] = useState(0);
        const [coverDays, setCoverdays] = useState('')
        const [quoteText, setQuotetext] = useState('Calculate Premium')
        const [stampduty, setStampduty] = useState(0)
        const [isCalculated, setIscalculated] = useState(false)
        const [paymentMode, setPaymentmode] = useState(0)
        const [walletBallance, setWalletbalance] = useState(0)
        const [walletNo, setWalletno] = useState('')
        const [dataLoaded, setDataloaded] = useState(0)
        const [isMpesa, setIsmpesa] = useState(true)
        const [utilize, setUtilize] = useState(0)
        const [availableCommission, setAvailablecommission] = useState(0)
        const [comm2, setComm2] = useState(0)
        const [nc2, setNc2] = useState(0)
        const [clientPhone, setClientphone] = useState('')
        const [promptID, setPromptid] = useState(0)
        const [modal3, setModal3] = useState(false)
        const [mpesaCode, setMpesacode] = useState('')
        const [checkMpesa, setCheckmpesa] = useState(false)
        const [verifyText, setVerifytext] = useState('VERIFY')
        const [agentName,setAgentname] = useState('')
        const [prdCode, setPrdcode] = useState('');
        const [insuredSchedule, setInsuredSchedule] = useState('')
        const [dealerCode,setDealercode] = useState('')
        const [isActive, setIsactive] = useState(0)
        const [ext,setExt] = useState(null)
        const [cmm,setCmm] = useState(null)
        
          useEffect(()=>{
          const getCredentials =async()=>{
            const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
            const data = await res.json();
            const {Username, Password} = data;
            const cred = btoa(`${Username}:${Password}`)
            setCredentials(btoa(`${Username}:${Password}`))
            setIsauth(true)
        
        
          }
          getCredentials()
        
          },[])
        
    
        useEffect(() => {
    
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
            setAgent(user)
        } else {
        
        }
        }, []);
    
        useEffect(()=>{
            const getAgentcode =async()=>{
                const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                    method:"GET",
                    headers:{
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    }
                });
                const data = await res.json();
                setAgentcode(data.OID)   
    
            }
            if(agent && isAuth){
                getAgentcode()
            }
        },[agent,isAuth])


        useEffect(()=>{

            const getProposals =async()=>{
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/getPendingproposals?agent=${agentCode}`,{
                     method:"GET",
                    headers:{
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    }
                    
                })

                const data = await res.json()
                setProposals(data)
            }

            if(agentCode && isAuth){
                getProposals()
            }

        },[agentCode,isAuth])
    
    function formateDateISO(input){
        if(typeof input === 'string'){
            return input.split('T')[0]
        }
        else if (input instanceof Date){
            return input.toISOString().split('T')[0]
        }

        throw new Error('Invalid input: Expected ISO String or Date Object')
    }

    function formatter(amount) {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      }

  return (
    <div>
        <div className="page-content">
            <ToastContainer />
            <Breadcrumbs title="Definite Assurance" breadcrumbItem="Pending Proposals" />
            <Card className="mini-stats-wid">
                <CardBody>
                    <h4>Pending Proposals {proposals.length}</h4>
                    <div className="table-responsive" style={{padding:'10px'}}>
                        <Table striped bordered hover id="policy-table">
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">Registration</th>
                            <th scope="col">Client</th>
                            <th scope="col">Product</th>     
                            <th scope="col">Gross Premium(KES)</th>
                            <th scope="col">Date Done</th>
                            <th scope="col">Commencement Date</th>
                            <th scope="col">Expiry Date</th>
                            
        
        
                            </tr>
                        </thead>
                        <tbody>
                            {proposals.map((val, index) => {
                            // Calculate the correct index based on current page
                          
        
                            return (
                                <tr key={val.OID}>
                                <td>{index + 1}</td>
                                <td><button value={val.OID} className="tableButton">{val.Narration}</button></td>
                                <td>{val.Dealer_name}</td>
                                <td>{val.ProductDescription}</td>
                                <td>{formatter(val.GrossPremium)}</td>
                                 <td>{formateDateISO(val.DateDone)}</td>
                               <td>{formateDateISO(val.CommencementDate)}</td>
                                <td>{formateDateISO(val.ExpiryDate)}</td>
                              
                                </tr>
                            );
        
                            })}
                        </tbody>
                        </Table>
                                </div>
                </CardBody>
            </Card>
        </div>
    </div>
  )
}
